<form *ngIf="isVersion2()" name="tableItemEditForm" #tableItemEditForm="ngForm">
  <div class="row">

    <div class="col-sm-8">
      <div class="form-group">
        <label for="JobPosition"><span class="mandatory">*</span>{{'RemunerationPeriodEditTable.JobPosition' | translate}}</label>
        <input class="form-control" type="text" placeholder="{{'Placeholders.RemunerationPeriodEditTable.JobPosition' | translate}}" [(ngModel)]="item.jobPosition" name="jobPosition" #jobPosition="ngModel" maxlength="60" required>
        <validation-message [control]="jobPosition"></validation-message>
      </div>
    </div>

    <div class="col-sm-4">
      <div class="form-group">
        <label for="Start">
          <span class="mandatory">*</span>{{'RemunerationPeriodEditTable.Start' | translate}}
          <span tabindex="0" class="ml-1 text-primary icon-help" tooltip="{{(isParentTriennium ? 'Tooltips.CardRemunerationsTriennium.StartDate'  : 'Tooltips.CardRemunerationsLastThreeYears.StartDate') | translate}}"></span>
        </label>

        <div class="input-group">
          <input #dpStartDate="bsDatepicker"
                 bsDatepicker
                 autocomplete="off"
                 type="text"
                 [required]="isVersion2()"
                 class="form-control DatepickerCustomClasse"
                 placeholder="{{'Placeholders.Generic.DateFormat' | translate}}"
                 [bsConfig]="{ dateInputFormat: 'YYYY-MM-DD', containerClass: 'theme-default', showWeekNumbers:false }"
                 [minDate]="minDate"
                 [maxDate]="item.endDate || maxDate"
                 maxlength="10"
                 [(ngModel)]="item.startDate" name="startDate" #startDate="ngModel" required externalValidation="remunerationsList" [tableIndex]="editIndex"
                 (keyup)="formatDate($event)" (keydown)="onlyNumbers($event)" (change)="onDateChange($event, dpStartDate)" />
          <div class="input-group-append disable-on-fieldset" (click)="!dpStartDate.isDisabled && dpStartDate.toggle()">
            <span class="input-group-text" id="basic-addon2">
              <i class="icon-calendar"></i>
            </span>
          </div>
          <validation-message [control]="startDate"></validation-message>
        </div>
      </div>
    </div>

  </div>
  <div class="row">

    <div class="col-sm-4">
      <div class="form-group">
        <label for="End">
          <span class="mandatory">*</span>{{'RemunerationPeriodEditTable.End' | translate}}
          <span tabindex="0" class="ml-1 text-primary icon-help" tooltip="{{(isParentTriennium ? 'Tooltips.CardRemunerationsTriennium.EndDate'  : 'Tooltips.CardRemunerationsLastThreeYears.EndDate') | translate}}"></span>
        </label>

        <div class="input-group">
          <input #dpEndDate="bsDatepicker" bsDatepicker
                 type="text"
                 autocomplete="off"
                 class="form-control DatepickerCustomClasse"
                 placeholder="{{'Placeholders.Generic.DateFormat' | translate}}"
                 [bsConfig]="{ dateInputFormat: 'YYYY-MM-DD', containerClass: 'theme-default', showWeekNumbers:false }"
                 [minDate]="getMinEndDate()"
                 [maxDate]="maxDate"
                 [required]="isVersion2()"
                 maxlength="10"
                 [(ngModel)]="item.endDate" name="endDate" #endDate="ngModel" required externalValidation="remunerationsList" [tableIndex]="editIndex"
                 (keyup)="formatDate($event)" (keydown)="onlyNumbers($event)" (change)="onDateChange($event,dpEndDate)" />
          <div class="input-group-append disable-on-fieldset" (click)="!dpEndDate.isDisabled && dpEndDate.toggle()">
            <span class="input-group-text" id="basic-addon2">
              <i class="icon-calendar"></i>
            </span>
          </div>
          <validation-message [control]="endDate"></validation-message>
        </div>
      </div>
    </div>

    <div class="col-sm-4">
      <div class="form-group">
        <label for="ScheduleType"><span class="mandatory">*</span>{{'RemunerationPeriodEditTable.ScheduleType' | translate}}</label>
        <select class="custom-select" [(ngModel)]="item.scheduleTypeCode" name="scheduleTypeCode" #scheduleTypeCode="ngModel" required
                [dropdownTitle]="{value : item.scheduleTypeCode, dimensions  : scheduleTypes }" nullableSelect>
          <default-dropdown-values></default-dropdown-values>
          <option *ngFor="let domain of scheduleTypes" [value]="domain.code">
            {{domain.description}}
          </option>
        </select>
        <validation-message [control]="scheduleTypeCode"></validation-message>
      </div>
    </div>

    <div class="col-sm-4">
      <div class="form-group">
        <label for="RemunerationValue"><span class="mandatory">*</span>{{'RemunerationPeriodEditTable.RemunerationValue' | translate}}</label>
        <div class="position-relative">
          <input class="form-control input-left" type="text" currency
                 placeholder="{{'Placeholders.Generic.Currency' | translate}}"
                 [(ngModel)]="item.remunerationValue" name="remunerationValue" #remunerationValue="ngModel" required maxValue="999000" messageFieldType="currency">
          <span class="input-icon-span-left">€</span>
          <validation-message [control]="remunerationValue"></validation-message>
        </div>
      </div>
    </div>
  </div>

  <span *ngIf="!tableItemEditForm.valid" class="text-danger validation_error_all">{{'Generic.ValidationErrorCardAll' | translate}}</span>

</form>

<form *ngIf="!isVersion2()" name="tableItemEditForm" #tableItemEditForm="ngForm">
  <div class="row">

    <div class="col-sm-8">
      <div class="form-group">
        <label for="JobPosition"><span class="mandatory">*</span>{{'RemunerationPeriodEditTable.JobPosition' | translate}}</label>
        <input class="form-control" type="text" placeholder="{{'Placeholders.RemunerationPeriodEditTable.JobPosition' | translate}}" [(ngModel)]="item.jobPosition" name="jobPosition" #jobPosition="ngModel" maxlength="60" required>
        <validation-message [control]="jobPosition"></validation-message>
      </div>
    </div>

    <div class="col-sm-4">
      <div class="form-group">
        <label for="Start">
          <span class="mandatory">*</span>{{'RemunerationPeriodEditTable.Start' | translate}}
          <span tabindex="0" class="ml-1 text-primary icon-help" tooltip="{{(isParentTriennium ? 'Tooltips.CardRemunerationsTriennium.StartDate'  : 'Tooltips.CardRemunerationsLastThreeYears.StartDate') | translate}}"></span>
        </label>

        <div class="input-group">
          <input #dpStartDate="bsDatepicker"
                 bsDatepicker
                 autocomplete="off"
                 type="text"
                 class="form-control DatepickerCustomClasse"
                 placeholder="{{'Placeholders.Generic.DateFormat' | translate}}"
                 [bsConfig]="{ dateInputFormat: 'YYYY-MM-DD', containerClass: 'theme-default', showWeekNumbers:false }"
                 [minDate]="minDate"
                 [maxDate]="item.endDate || maxDate"
                 maxlength="10"
                 [(ngModel)]="item.startDate" name="startDate" #startDate="ngModel" required externalValidation="remunerationsList" [tableIndex]="editIndex"
                 (keyup)="formatDate($event)" (keydown)="onlyNumbers($event)" (change)="onDateChange($event, dpStartDate)" />
          <div class="input-group-append disable-on-fieldset" (click)="!dpStartDate.isDisabled && dpStartDate.toggle()">
            <span class="input-group-text" id="basic-addon2">
              <i class="icon-calendar"></i>
            </span>
          </div>
          <validation-message [control]="startDate"></validation-message>
        </div>
      </div>
    </div>

  </div>
  <div class="row">

    <div class="col-sm-4">
      <div class="form-group">
        <label for="End">
          <span class="mandatory">*</span>{{'RemunerationPeriodEditTable.End' | translate}}
          <span tabindex="0" class="ml-1 text-primary icon-help" tooltip="{{(isParentTriennium ? 'Tooltips.CardRemunerationsTriennium.EndDate'  : 'Tooltips.CardRemunerationsLastThreeYears.EndDate') | translate}}"></span>
        </label>

        <div class="input-group">
          <input #dpEndDate="bsDatepicker" bsDatepicker
                 type="text"
                 autocomplete="off"
                 class="form-control DatepickerCustomClasse"
                 placeholder="{{'Placeholders.Generic.DateFormat' | translate}}"
                 [bsConfig]="{ dateInputFormat: 'YYYY-MM-DD', containerClass: 'theme-default', showWeekNumbers:false }"
                 [minDate]="getMinEndDate()"
                 [maxDate]="maxDate"
                 maxlength="10"
                 [(ngModel)]="item.endDate" name="endDate" #endDate="ngModel" required externalValidation="remunerationsList" [tableIndex]="editIndex"
                 (keyup)="formatDate($event)" (keydown)="onlyNumbers($event)" (change)="onDateChange($event, dpEndDate)" />
          <div class="input-group-append disable-on-fieldset" (click)="!dpEndDate.isDisabled && dpEndDate.toggle()">
            <span class="input-group-text" id="basic-addon2">
              <i class="icon-calendar"></i>
            </span>
          </div>
          <validation-message [control]="endDate"></validation-message>
        </div>
      </div>
    </div>

    <div class="col-sm-4">
      <div class="form-group">
        <label for="ScheduleType"><span class="mandatory">*</span>{{'RemunerationPeriodEditTable.ScheduleType' | translate}}</label>
        <select class="custom-select" [(ngModel)]="item.scheduleTypeCode" name="scheduleTypeCode" #scheduleTypeCode="ngModel" required
                [dropdownTitle]="{value : item.scheduleTypeCode, dimensions  : scheduleTypes }" nullableSelect>
          <default-dropdown-values></default-dropdown-values>
          <option *ngFor="let domain of scheduleTypes" [value]="domain.code">
            {{domain.description}}
          </option>
        </select>
        <validation-message [control]="scheduleTypeCode"></validation-message>
      </div>
    </div>

    <div class="col-sm-4">
      <div class="form-group">
        <label for="RemunerationValue"><span class="mandatory">*</span>{{'RemunerationPeriodEditTable.RemunerationValue' | translate}}</label>
        <div class="position-relative">
          <input class="form-control input-left" type="text" currency
                 placeholder="{{'Placeholders.Generic.Currency' | translate}}"
                 [(ngModel)]="item.remunerationValue" name="remunerationValue" #remunerationValue="ngModel" required maxValue="999000" messageFieldType="currency">
          <span class="input-icon-span-left">€</span>
          <validation-message [control]="remunerationValue"></validation-message>
        </div>
      </div>
    </div>
  </div>

  <span *ngIf="!tableItemEditForm.valid" class="text-danger validation_error_all">{{'Generic.ValidationErrorCardAll' | translate}}</span>

</form>

<div class="d-flex justify-content-between mt-4 mb-2">
  <button type="button" class="btn btn-outline-primary disable-on-fieldset" (click)="onRemove(isEdit)"><span [ngClass]="isEdit ? 'icon-trash' : 'icon-close'"></span><span>{{isEdit ?  'Remover' : 'Cancelar'}}</span></button>
  <button type="button" class="btn btn-primary disable-on-fieldset" aria-label="Aplicar" (click)="onEdit(isEdit)"><span class="icon-check"></span><span>Aplicar</span></button>
</div>
